import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import QRCode from 'qrcode.react';

// error notification box

// set up amplify config
import { Amplify, Auth } from 'aws-amplify';  
import awsconfig from '../../aws-exports';

import { useNavigate } from 'react-router-dom';

import '../../../src/styles/login.css';

import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import { isUserRegistered } from '../../redux/actions/checkUserRegister';

import { application, business } from '../../config';
import { url } from '../../api/endpointURL';
import { webURL, contactEmailSupport, MFAGuide } from '../../config';

// Import generic components
import Card from '../../generic_components/Card/Card';
import Input from '../../generic_components/Input/Input';
import Button from '../../generic_components/Button/Button';
import Modal from '../../generic_components/Modal/Modal';
import Tooltip from '../../generic_components/Tooltip/Tooltip';
import Footer from '../../generic_components/Footer/Footer';
import { useToast } from '../../generic_components/Toast/Toast';

// import rbacData Action from redux
import { rbacDataAction } from '../../redux/actions/rbacAction';

Amplify.configure(awsconfig);

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [code, setCode] = useState('');
  const [userData, setUserData] = useState({});
  const [showSignup, setShowSignup] = useState(false);
  const [showResetPass, setShowResetPass] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isMFA, setIsMFA] = useState(false);
  const [MFAconfirm, setMFAconfirm] = useState(false);
  const [loadingVerificationCode, setLoadingVerificationcode] = useState(false);
  const [loadingSignIn, setLoadingSignIn] = useState(false);
 
  const [isTOTPsetUpRequired, setIsTOTPsetUpRequired] = useState(false);
  const [TOTPsetupCode, setTOTPsetupCode] = useState('');
 
  const checkUser = useSelector((state => state.checkUser));

  const toast = useToast();


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }

  const handlePasswordChange = (e) => {
      setPassword(e.target.value);
  }
 
  // Sign up modal
  const handleCloseSignup = () => {
    setShowSignup(false);    
  } 

  const handleShowSignup = () => {   
    setShowSignup(true);    
  }

 // Forgote Password modal
  const handleCloseResetPass = () => {
    setShowResetPass(false);    
  } 

  const handleShowResetPass = () => {   
    setShowResetPass(true);    
  }

  
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetch_user_check = window.localStorage.getItem('fetch_user_check');   
    
    if (submitted && MFAconfirm && fetch_user_check === 'true') {
      // Successful login
      let successMsg = `Your login was successful. Welcome to ${application}!`;
      toast.success(successMsg, {
        autoClose: 9000,
        hideProgressBar: true
      });
      
       // check if the email registered to the user database. Dont need   
    // if (checkUser.response === 'true') {
      localStorage.setItem('email', email);
      
      if (localStorage.getItem('nav') === 'report') {
        navigate("/report");
      }
      else
        navigate("/health"); 
    }
    
  }, [navigate, checkUser, MFAconfirm, submitted, toast, email]);


  const confirmHandleLogin = async(e) => {
    e.preventDefault();
    try {
        await Auth.confirmSignIn(userData, code, 'SOFTWARE_TOKEN_MFA');
        setLoadingSignIn(true);
        setMFAconfirm(true);
        dispatch(isUserRegistered(email));
        await fetchAndStoreRBAC(email);
    } catch (error) {
      setLoadingSignIn(false);
        if (error.message === 'Invalid session for the user, session is expired.') {
          let errorMsg = 'session is expired, please login again.';
          toast.error(errorMsg, {
            hideProgressBar: true
          });
          
          setIsMFA(false);
        }
        else {
          toast.error(error.message, {
            hideProgressBar: true
          });
        }       
    }
  }

  const handleCancel = () => {
    setIsMFA(false);
    setEmail('');
    setPassword('');
    setLoadingVerificationcode(false);
    setLoadingSignIn(false);
    localStorage.clear();
    navigate('/');
  }

  const isSmallScreen = window.innerWidth < 600;

  const verifyTOTP = async (e) => {
    e.preventDefault();
    try {
      await Auth.signIn(email, password);
      setLoadingSignIn(true);
      await Auth.verifyTotpToken(
        userData,
        code
      );
     
      // set TOTP as the preferred MFA method.
      await Auth.setPreferredMFA(userData, 'TOTP');
      setLoadingSignIn(false);
      setMFAconfirm(true);
      dispatch(isUserRegistered(email));
      await fetchAndStoreRBAC(email);

    } catch (error) {  
        toast.error(error.message, {
          hideProgressBar: true
        });
    }
  }

  const handleTOTPSetup = async (user) => {       
      try {
      const secretCode = await Auth.setupTOTP(user);
        setTOTPsetupCode(secretCode);
        setIsTOTPsetUpRequired(false);
      } 
      catch (error) {
      console.error('Error setting up TOTP:', error);
      toast.error(error.message, {
        hideProgressBar: true
      });
    }
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    try{
      setLoadingVerificationcode(true);
      const user = await Auth.signIn(email, password);
      setLoadingVerificationcode(false);
      setUserData(user);

      // check if first time TOTP setup required
      if (user.challengeName === "MFA_SETUP") {
        setIsTOTPsetUpRequired(true);
        await handleTOTPSetup(user); // set up TOTP (Authenticator app MFA)
      }

      // Subsequent sign in
      if (user.challengeName === "SOFTWARE_TOKEN_MFA") {
        setIsMFA(true);
      }
    } catch (error) {
        console.log(error.message)
      setLoadingVerificationcode(false);
      if (error.message === 'User is not confirmed.') {
        let errorMsg = 'You can not login because user verification is pending. Please contact Art of Logic support (support@artoflogictech.com) to confirm verification.'; 
        toast.error(errorMsg, {
          hideProgressBar: true
        });       
      }
      else if (error.message === 'User does not exist.') {
        let errorMsg = `${email} does not exist. Please Sign up to create a user.`;
        toast.error(errorMsg, {
          hideProgressBar: true
        });
      }
      else if (error.message === 'Custom auth lambda trigger is not configured for the user pool.') {
        let errorMsg = "Password can't be blank";
        toast.error(errorMsg, {
          hideProgressBar: true
        });      
      }
      else if (error.message === 'Invalid session for the user, session can only be used once.') {
      
        setIsMFA(false);
      }
      else {
        let errorMsg = error.message; 
        toast.error(errorMsg, {
          hideProgressBar: true
        });      
      }
    }
  }
  
  const fetchAndStoreRBAC = async (email) => {
    try {
      const url_path = url+'/fetch_rbac'; // Use environment variable or default to localhost
      
      const response = await fetch(url_path, { // Fixed URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ user: email })
      });
      localStorage.removeItem('rbac_role');
      localStorage.removeItem('rbac_data');
      
      const rbacData = await response.json();
      // console.log("RBAC fetched:", rbacData);

      localStorage.setItem('rbac_role', rbacData.global_role);
      localStorage.setItem('rbac_data', JSON.stringify(rbacData.business_roles));

      // Dispatch to redux store
      dispatch(rbacDataAction(rbacData));

    } catch (error) {
      console.error('Error fetching RBAC data:', error);
      toast.error("Error fetching RBAC data.", {
        hideProgressBar: true
      });      
    }
  };

  const tooltipContent = {
    title: "Setting up Multi-Factor Authentication",
    instructions: [
        "Download Google Authenticator, Microsoft Authenticator, or Authy from your App Store/Google Play.",
        "Open the app, tap +, then select Scan a QR code.",
        "Point your phone camera at the QR code shown during setup.",
        "The app will display a 6-digit code. Enter it in the box and click submit.",
        "For future sign-ins, open your authenticator app and enter the 6-digit code shown.",
        <span>For further details, please download the <a href={MFAGuide} className="mfa-link">MFA Setup Guide</a> or contact <a href={`mailto:${contactEmailSupport}`} className="mfa-link">{contactEmailSupport}</a>.</span>      
    ],
  };

  const handleShowPassword = () => {
    setShowPassword(prev => !prev);
  };


  return (
   <>
    {/* {!isSmallScreen &&
    <div className='login-sidebar-container'>
      <SideBar />
    </div>} */}
    <div id='login-container'>
       <Card className='no-hover no-shadow glass-card' style={{width: '400px'}}>
        {/* <Card.Body> */}
        {/* <Card.Title style={{ textAlign: 'center'}}><span className='card-title'>Get started!</span></Card.Title> */}
        <div className='card-title-sign-in'>Get started!</div>
        <form onSubmit={handleSignin}>        
          <Input
            id='email'
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={handleEmailChange}
            size='lg'
          />
          <br></br>

          <div className='signin-password-container'>
            <Input             
              type={showPassword ? "text":"password"}
              placeholder="Enter password"
              value={password}
              onChange={handlePasswordChange}
              size='lg'
            />
            <button className='show-password-btn' type='button' onClick={handleShowPassword}>
              {showPassword ? <i className="fa-regular fa-eye-slash"></i> : <i className="fa-regular fa-eye"></i> }
            </button>
          </div>
          <br></br>
          <Button className='signin-btn' variant='primary' type='submit'>Sign in</Button>
        </form>

        {!isTOTPsetUpRequired && TOTPsetupCode &&
          <div id='qrcode-text'>          
            {/* <span style={{ opacity: '0.95' }}>Scan the QR code with your authenticator app or enter the secret code manually.</span> */}
            {/* <span style={{ opacity: '0.95' }}>Scan the QR code with your authenticator app.</span> */}
            <div style={{ opacity: '0.95', marginBottom: '0.5rem'}}>
              <Tooltip
                tooltipStyle={{width: isSmallScreen ? '310px' : '400px'}}
                placement={isSmallScreen ? 'right' : 'top-start'}
                size='md'
                trigger='click'
                content={(
                  <>
                    <h4 style={{ 
                        color: '#4A90E2', 
                        marginBottom: '10px', 
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }}>
                        {tooltipContent.title}
                    </h4>
                    <ul style={{ 
                        listStyle: 'none', 
                        padding: '0', 
                        margin: '0' 
                    }}>
                        {tooltipContent.instructions.map((instruction, index) => (
                            <li key={index} style={{ 
                                marginBottom: '6px',
                                paddingLeft: '15px',
                                position: 'relative'
                            }}>
                                <span style={{
                                    position: 'absolute',
                                    left: '0',
                                    color: '#4A90E2'
                                }}>•</span>
                                {instruction}
                            </li>
                        ))}
                    </ul>
                  </>)}>
                <i className="fa-solid fa-circle-info" style={{color: '#fafafa', cursor: 'pointer'}}></i>
              </Tooltip>
              <span> Scan the QR code with your authenticator app.</span>
            </div>

            {/* <div className='qrcode-text-code-div'><span style={{ color: 'white' }}>Secret Code:</span> <span id='qrcode-text-code'>{TOTPsetupCode}</span></div> */}
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <QRCode value={`otpauth://totp/ArtofLogic:${email}?secret=${TOTPsetupCode}&issuer=${business}`}/>
            </div>
            <br></br>
            <form onSubmit={verifyTOTP}>
              <Input
                type="text"
                placeholder="Enter authenticator code "
                value={code}
                onChange={(e) => setCode(e.target.value)}
                size='md'
              />
              <br></br>
              <Button type="submit" className='signin-submit-code-btn' variant='primary'>Submit code</Button>
            </form>
          </div>
        }
       
        { loadingVerificationCode ?
          <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
            <BeatLoader size={5} color="#36d7b7"/>
          </div> :
          <div style={{ marginTop: '0.0em', height: '1.5em' }}>
          
        </div> 
        }       

        {isMFA && (
        <div>
          <div>
          <div id='signin-mfa-text'>              
              Please enter the code from your registered authenticator app. Once the code is entered, click on Submit Code button.
            </div>
            <form onSubmit={confirmHandleLogin}>
              <Input           
                type="text"
                placeholder="Enter authenticator code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                size='md'
              />
              <br></br>
              <Button type="submit" className='signin-submit-code-btn' disabled={loadingSignIn}>Submit code</Button>            
            </form>
            { loadingSignIn ?
           <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
            <BeatLoader size={5} color="#36d7b7"/>
            </div> :
            <div style={{ marginTop: '0.0em', height: '1.5em' }}>
         
            </div> 
            }

          </div>
        </div>
      )}
      
        <div id='bottom-text'>
          <span style={{ color: 'white' }}>Dont't have an account ?</span>

          <Button variant='ghost' size='small' onClick={() => handleShowSignup()}>
            Sign up
          </Button>
          <br></br>
        
          <button id='bottom-btn' onClick={() => handleShowResetPass()}>
            Forgot password ?
          </button>
        
        </div>
        <div id='bottom-text' style={{ color: 'lightgray', fontSize: '0.74rem' }}>*If you lost your authenticator device, please contact Art of Logic.</div>
        
        {/* </Card.Body> */}
        <div style={{display: 'flex', justifyContent: 'end'}}>
          <Button variant="blank" onClick={() => handleCancel()}>
            Cancel
          </Button>
        </div>
    </Card>    

    {/* modal to view Signup modal*/}

    <Modal size='md' show={showSignup} onHide={handleCloseSignup} position='center'>
        <Modal.Header >
          <div >
            <Modal.Title >Create a new account</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body >
          <SignUp  onClose={handleCloseSignup} />
        </Modal.Body>
      </Modal>

      
    {/* modal to view Forgot Password modal*/}

    <Modal size='md' show={showResetPass} onHide={handleCloseResetPass} position='center' >
        <Modal.Header >
        <div >
          <Modal.Title >Reset your password</Modal.Title>
        </div>
        </Modal.Header>
        <Modal.Body>
          <ForgotPassword  username={email} onClose={handleCloseResetPass}  />
        </Modal.Body>
      </Modal>   

    </div>
    <div className='signin-footer-container' style={{ marginTop: '10em', padding: '1em' }}>
      <Footer url={webURL}/>
    </div>
    </>
    
  );
};

 

export default LoginPage;
